import Long from 'long';
import {IUpdate} from '../../../api/proto';
import {IRawChat} from '../RawChat';

export default function getRawChatFromUpdateEntities(update: IUpdate, chatId?: Long | null): IRawChat | null {
  return update?.entities?.chats?.find(({id}) => chatId && id?.equals(chatId)) || null;
}
